<template>
  <el-card style="padding-top: 20px; padding-left: 50px">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="系统配置" name="systemInfoConfig">
        <system-info-config v-if="activeName === 'systemInfoConfig'" />
      </el-tab-pane>
      <el-tab-pane label="参数管理" name="paramsEnvConfig">
        <el-alert
          class="title"
          :closable="false"
          title="系统会自动根据拼接的参数记录控制问卷题目或确认问卷结果归属。例子：https://XXXXXX?code=[code]&orderid=[orderid]&products=[products]&province=[province]&city=[city]"
          type="info"
        >
        </el-alert>
        <el-form class="form" style="margin-top: 20px" disabled>
          <el-col v-for="(item, index) in paramDos" :key="index">
            <el-form-item class="page-select--item middle">
              <el-select v-model="item.type" placeholder="请选择">
                <el-option label="门店编码" :value="0"> </el-option>
                <el-option label="订单号" :value="1"> </el-option>
                <el-option label="菜品编码" :value="2"> </el-option>
                <el-option label="省份" :value="3"> </el-option>
                <el-option label="城市" :value="4"> </el-option>
                <el-option label="会员卡号" :value="5"> </el-option>
                <el-option label="用户凭证" :value="6"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="page-select--item middle">
              <el-input v-model="item.param" />
            </el-form-item>
            <el-form-item v-if="item.type === 2" class="page-select--item middle">
              <el-input v-model="item.linker">
                <span slot="prepend">连接符</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import ConfigMixin from './subconfig/ConfigMixin'
import SystemInfoConfig from './subconfig/SystemInfoConfig.vue'
const paramDos = [
  { type: 0, param: 'code' },
  { type: 1, param: 'orderid' },
  { type: 2, param: 'products', linker: '|' },
  { type: 3, param: 'province', linker: '|' },
  { type: 4, param: 'city', linker: '|' },
  { type: 5, param: 'userCardNo' },
  { type: 6, param: 'token' }
]
export default {
  name: 'ConfigForm',
  components: { SystemInfoConfig },
  mixins: [ConfigMixin],
  data() {
    return {
      paramDos
    }
  },
  methods: {
    handleTabClick() {
      if (!['systemInfoConfig', 'paramsEnvConfig'].includes(this.activeName)) {
        this.handleClick()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-cascader--item,
.page-select--item {
  width: 170px;
  display: inline-block;
  margin-right: 10px;
  &.mini {
    width: 100px;
  }
  &.middle {
    width: 120px;
  }
  &:last-child {
    margin-right: 0 !important;
  }
}
.input-with-select {
  width: 240px;
}
</style>
